(function () {
  var mq = window.matchMedia('(min-width: 750px)');

  function setupTabs(infoContainer, mediaWrapper) {
    if (mediaWrapper.querySelector('.wh-desktop-tabs-wrap')) return;

    var accordions = Array.prototype.slice.call(
      infoContainer.querySelectorAll('.product__accordion')
    );
    if (!accordions.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'wh-desktop-tabs-wrap';
    wrap.style.cssText =
      'width:100%;display:block;clear:both;position:relative;z-index:5;';

    var nav = document.createElement('div');
    nav.className = 'wh-tabs-nav';
    wrap.appendChild(nav);

    var detailsEls = [];
    var contentEls = [];

    accordions.forEach(function (acc, i) {
      acc._whOriginalParent = acc.parentNode;
      acc._whOriginalNext = acc.nextSibling;

      var detailsEl = acc.querySelector('details');
      if (!detailsEl) return;
      detailsEls.push(detailsEl);

      var contentEl = detailsEl.querySelector('.accordion__content');
      if (contentEl) contentEls.push(contentEl);

      var titleEl = acc.querySelector('.accordion__title');
      var label = titleEl ? titleEl.textContent.trim() : 'Tab ' + (i + 1);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wh-tab-btn' + (i === 0 ? ' active' : '');
      btn.textContent = label;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        nav.querySelectorAll('.wh-tab-btn').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        detailsEls.forEach(function (d) {
          d.removeAttribute('open');
        });
        detailsEl.setAttribute('open', '');
      });

      nav.appendChild(btn);
      acc.style.cssText = 'width:100%;display:block;';
      wrap.appendChild(acc);
    });

    detailsEls.forEach(function (d) {
      d.removeAttribute('open');
    });
    if (detailsEls[0]) detailsEls[0].setAttribute('open', '');

    var galleryEl = mediaWrapper.querySelector('media-gallery');
    if (galleryEl) {
      galleryEl.insertAdjacentElement('afterend', wrap);
    } else {
      mediaWrapper.appendChild(wrap);
    }

    // Lock the content area to the tallest tab's height so switching
    // tabs never changes the page height (this is what stops the
    // image from jumping up/down when you click a different tab).
    requestAnimationFrame(function () {
      var maxHeight = 0;
      detailsEls.forEach(function (d) {
        d.setAttribute('open', '');
      });
      contentEls.forEach(function (c) {
        if (c.scrollHeight > maxHeight) maxHeight = c.scrollHeight;
      });
      detailsEls.forEach(function (d) {
        d.removeAttribute('open');
      });
      detailsEls[0].setAttribute('open', '');

      contentEls.forEach(function (c) {
        c.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function restoreTabs() {
    var wrap = document.querySelector('.wh-desktop-tabs-wrap');
    if (!wrap) return;

    Array.prototype.slice.call(wrap.querySelectorAll('.product__accordion')).forEach(function (acc) {
      acc.style.cssText = '';
      var contentEl = acc.querySelector('.accordion__content');
      if (contentEl) contentEl.style.minHeight = '';
      if (acc._whOriginalNext) {
        acc._whOriginalParent.insertBefore(acc, acc._whOriginalNext);
      } else if (acc._whOriginalParent) {
        acc._whOriginalParent.appendChild(acc);
      }
    });
    wrap.remove();
  }

  function handleChange(sectionId) {
    var infoContainer = document.getElementById('ProductInfo-' + sectionId);
    var mediaWrapper = document.querySelector(
      '#MainProduct-' + sectionId + ' .product__media-wrapper'
    );
    if (!infoContainer || !mediaWrapper) return;

    if (mq.matches) {
      setupTabs(infoContainer, mediaWrapper);
    } else {
      restoreTabs();
    }
  }

  document.querySelectorAll('product-info').forEach(function (el) {
    var sectionId = el.getAttribute('data-section');
    handleChange(sectionId);
    mq.addEventListener('change', function () {
      handleChange(sectionId);
    });
  });
})();